import {isAssembliesEnabled} from 'helpers/partContents'
import {getUser} from 'selectors/auth'
import {PartType} from 'helpers/parts'
import {isComplexPricingEnabled as isComplexPricingEnabledHelper} from 'helpers/pricing'

export const getPriceList = (state, priceListId) => priceListId
    ? state.data.priceLists.find(p => p.visible && p.id === priceListId)
    : null

export const getPriceLists = (state) => state.data.priceLists.filter(p => p.visible)

export const getPackTypes = (state) => state.data.packTypes || []

export const getPartTemplates = (state) => {
  const user = getUser(state)
  const partTemplates = state.data.partTemplates || []
  return isAssembliesEnabled(user)
      ? partTemplates
      : partTemplates.filter(partTemplate => partTemplate.partType !== PartType.ASSEMBLY.id)
}

export const getPart = (state) => state.priceListsContext.part.part

export const getPartCategoryTreeSelectField = (state) => state.priceListsContext.partCategoryTreeSelectField

export const getSelectedPartPackId = (state) => state.priceListsContext.part.selectedPartPackId

export const getSelectedPartSupplierId = (state) => state.priceListsContext.part.selectedPartSupplierId

export const isComplexPricingEnabled = state => isComplexPricingEnabledHelper(getUser(state))

export const isPartSelectorOpen = state => state.priceListsContext.parts.open

export const getExpandedCategories = state => state.priceListsContext.expandedCategories

export const getPartCategories = state => state.data.partCategories

export const getMovePartsDialog = state => state.priceListsContext.movePartsDialog

export const isPartCategoryDetailsExpanded = state => state.priceListsContext.partCategoryDetailsExpanded

export const isSuppliersOpen = state => state.priceListsContext.suppliersOpen
